import React, { FC } from 'react';
import clsx from 'clsx';

interface Props {
  percent: number;
  additionalClass?: string;
}
export const ProgressBar: FC<Props> = ({ percent, additionalClass }) => {
  return (
    <progress
      className={clsx(percent >= 75 && 'red', additionalClass)}
      max="100"
      value={percent}
    />
  );
};